import { render, staticRenderFns } from "./PlanNoteTile.vue?vue&type=template&id=2f5cc950&scoped=true&"
import script from "./PlanNoteTile.vue?vue&type=script&lang=js&"
export * from "./PlanNoteTile.vue?vue&type=script&lang=js&"
import style0 from "./PlanNoteTile.vue?vue&type=style&index=0&id=2f5cc950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5cc950",
  null
  
)

export default component.exports